import { render } from "./App.vue?vue&type=template&id=5eddfd6f&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5eddfd6f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5eddfd6f"

export default script